import { render } from "./ProjectDetailsConfig.vue?vue&type=template&id=f65d006a&scoped=true"
import script from "./ProjectDetailsConfig.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsConfig.vue?vue&type=script&lang=js"

import "./ProjectDetailsConfig.vue?vue&type=style&index=0&id=f65d006a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65d006a"]])

export default __exports__